// extracted by mini-css-extract-plugin
export var ratingTitle = "UserReviewMps-module--ratingTitle--057ff";
export var reviewCountContent = "UserReviewMps-module--reviewCountContent--5a1c9";
export var reviewCountTitle = "UserReviewMps-module--reviewCountTitle--58860";
export var reviewHeader = "UserReviewMps-module--reviewHeader--1fbe0";
export var reviewIcons = "UserReviewMps-module--reviewIcons--76dab";
export var reviewImage = "UserReviewMps-module--reviewImage--113a7";